import { render, staticRenderFns } from "./purchase-payment-status-select.vue?vue&type=template&id=6c7694a2&scoped=true&"
import script from "./purchase-payment-status-select.vue?vue&type=script&lang=js&"
export * from "./purchase-payment-status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7694a2",
  null
  
)

export default component.exports